import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
  Tag,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;
class RawMaterialByStock extends Component {
  constructor() {
    super();
  }
  state = {
    details: [],
    newdetails: [],
    data: [],
  };

  componentDidMount() {
    const details = [];
    axios
      .get(`${getServerUrl()}/inventory/getmaterialstockbytransfer/`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = res.data.data;
        const details = responsevalue;
        console.log(details);
        this.setState({ details });
      });
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  render() {
    const data = this.state.details;

    const columns = [
      {
        title: "RM DC.No",
        dataIndex: "stid",
        key: "stid",
        ...this.getColumnSearchProps("stid"),
        render: (text, record) => "RM-" + record.stid,
      },
      {
        title: "RM Date",
        dataIndex: "stocktransfercreate_date",
        key: "stocktransfercreate_date",
      },
      {
        title: "Raw Material Batch",
        dataIndex: "rawbatch",
        key: "rawbatch",
        ...this.getColumnSearchProps("rawbatch"),
      },
      {
        title: "Contractor",
        dataIndex: "contractor_name",
        key: "contractor_name",

        ...this.getColumnSearchProps("contractor_name"),
      },
      {
        title: "Raw Material Name",
        dataIndex: "raw_material_name",
        key: "raw_material_name",

        ...this.getColumnSearchProps("raw_material_name"),
      },
      {
        title: "Raw Material Variant",
        dataIndex: "rawvariant",
        key: "rawvariant",

        ...this.getColumnSearchProps("rawvariant"),
      },

      {
        title: "Total Stock",
        dataIndex: "quantity",
        key: "quantity",
        sorter: {
          compare: (a, b) => a.quantity - b.quantity,
          multiple: 1,
        },
      },
      {
        title: "Assigned Stock",
        dataIndex: "usedquantity",
        key: "usedquantity",
        sorter: {
          compare: (a, b) => a.usedquantity - b.usedquantity,
          multiple: 1,
        },
        render: (text, record) => Number(record.usedquantity).toFixed(2),
      },
      {
        title: "Remaining Stock",
        dataIndex: "remainquantity",
        key: "remainquantity",
        sorter: {
          compare: (a, b) => a.remainquantity - b.remainquantity,
          multiple: 1,
        },
        render: (text, record) => Number(record.remainquantity).toFixed(2),
      },
      {
        title: "View / Assign",
        dataIndex: "rawtype_id",
        key: "rawtype_id",
        render: (text, record) => (
          <Space size="middle">
            <NavLink to={"/task-to-contractor/" + record.stid}>
              View / Assign
            </NavLink>
          </Space>
        ),
      },
      {
        title: "Download DC",
        dataIndex: "stid",
        key: "stid",
        render: (text, record) => (
          <Space size="middle">
            <a
              href={"/dc/rawmaterialdc.html?id=" + record.stid}
              target="_blank"
              type="secondary"
            >
              DOWNLOAD
            </a>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Inventory </Breadcrumb.Item>
          <Breadcrumb.Item>
            Delivery Challan & RM Schedule Creation
          </Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            DELIVERY CHALAN &<span> RM SCHEDULE CREATION</span>
          </h2>

          <Space></Space>
          <br />
          <Table
            scroll={{ x: 1300 }}
            columns={columns}
            dataSource={data}
          ></Table>
        </div>
      </div>
    );
  }
}

export default RawMaterialByStock;
